export const attachVerifySDK = () => {
  const externalScript = document.createElement('script')
  externalScript.setAttribute(
    'src',
    'https://cdn.veriff.me/incontext/js/v1/veriff.js'
  )
  document.head.appendChild(externalScript)
}
